  import { Component, OnInit } from '@angular/core';
import { User } from '../user';
import { UserService } from '../user.service';
import { Router } from '@angular/router';
import { GlobalDataService } from '../../../../services/global-data.service';


@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css'],
  providers: [UserService]
})
export class UserComponent implements OnInit {

 users: User[];
 loading: boolean = false;
 searchFilter: any = [];
 searchColumn: any = [];

 
 

  constructor(
    private userService: UserService, 
    private global: GlobalDataService,
    private router: Router) { }

  ngOnInit() {
    this.fillSearchColumn();
      this.loading= true;
       // this.carService.getCarsSmall().then(cars => this.cars = cars);
        this.userService.getUser().subscribe(response=>{
                this.users = response['data'];
                //  this.users = this.users.map(function(object: any,index: any){ret}) ;
                console.log(this.users['roles']);
                this.loading= false;
              })
        // // .subscribe(user=> this.users=user.body.data);
        // .subscribe(user=> {this.users=user.data.map(function(object: any,index: any){
        //   console.log(object);
        //   console.log("label"+index);
        //   return {
        //           'id' : object.id,
        //           'fio' : object.full_name, 
        //           'stores' : object.stores.map((object: any)=>{return " "+(+index+1) + ". "+object.name+" "}), 
        //           'roles' : object.roles.map((object: any,index: any)=>{return " "+(+index+1) + ". "+object.name+" "}),
        //           'created' : object.created_at,
        //           'last_login_at' : object.last_login_at,
        //           'available' : object.available == true ? 'Да' : 'Нет'
        //         }; 
        // }); console.log(user.body.data);console.log(user);});


    }


  fillSearchColumn() {
    this.searchColumn=[];
    this.searchColumn.push({ label: "Логин", value: { column: "login", type: "textbox" } });
    this.searchColumn.push({ label: "ФИО", value: { column: "full_name", type: "textbox" } });
    this.searchColumn.push({ label: "Компания", value: { column: "contractor_name",type: "textbox"} });
    this.searchColumn.push({ label: "Склад", value: { column: "store_id", type: "dropdown",value: this.global.user.stores.map(value => {
      return { label: value.name, value: { value: value.id, label: value.name } };
    }) } });
  }
  setFilter(data){
    this.searchFilter=data;
    this.loading = true;
    this.userService.getUserByFilter(this.searchFilter).subscribe(response=>{ this.users = response['data']; this.loading = false;});
  }

  exposeRole(data: any[]){
        return data['roles'].map(object=>{return object.display_name+" "}); 
  }

  exposeStore(data: any[]){
      return data['stores'].map(object=>{return object.name+" "}); 
  }  

  add():void {

    this.router.navigate(['/dashboard/user-crud']);
  }  

  edit(id: any){

   this.router.navigate(['/dashboard/user-crud/',id]);
    //this.userService.getUsersById(id).subscribe(user=>{console.log(user);});
  }


}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/users/user/user.component.ts